import style from "./DeskTopProductDetail.module.scss";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import { addCommas, clone, decode } from "shared/utils/Utils";
import { storeRequester } from "App";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";

import Flex from "layouts/flex/Flex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Inline from "layouts/container/Inline";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import InputNumber from "components/inputs/InputNumber";
import Container from "layouts/container/Container";
import cartIcon from "resources/img/cartIcon.svg";
import { getCookie } from "shared/StoreRequester";
import { toast } from "react-toastify";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import Dummy from "components/Dummy";
import { getCustomPriceDisplay } from "shared/utils/Utils";


function DeskTopProductDetail() {
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName } = useContext(AuthContext);
  const { id } = useParams();
  const [product, setProduct] = useState();
  const { t } = useTranslation();
  const inputs = useRef({});
  const [items, setItems] = useState([]);
  const [isIncrease, setIsIncrease] = useState(false);
  // const [quantity, setQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0); // 총 금액 상태

  useEffect(() => {
    if (inputs.current.length > 0) {
      inputs.current.forEach((input, index) => {
        const value = input?.getValue ? input.getValue() : null;

        if (value !== 0) {
          setItems((prevItems) => {
            const updatedItems = prevItems.map((item) =>
              item.index === index ? { ...item, quantity: value } : item
            );
            return updatedItems;
          });
        } else {
          setItems((prevItems) =>
            prevItems.filter((item) => item.index !== index)
          );
        }
      });
    }
  }, [inputs.current, isIncrease]);
  useEffect(() => {
    let searchCondition = clone(initialSearchCondition);
    searchCondition.productId = id;

    // if (id.startsWith("prod")) {
    storeRequester.getProduct(
      id,
      {
        expand: "images",
        // with_price: true,
        type: "main",
      },
      // ({ product }) => setProduct(product)
      ({ product }) => {
        setProduct(product);

      }
    );

    // } else if (id.startsWith("variant")) {
    //   storeRequester.getVariant(
    //     id,
    //     {
    //       expand: "product,prices",
    //       with_price: true,
    //     },
    //     ({ variant }) => setProduct(variant.product)
    //   );

    // }
  }, []);
  // useEffect(() => {
  //   if (items && items.length > 0) {
  //     const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
  //     setQuantity(totalQuantity);
  //   }
  // }, [items]);
 
  // 총 금액 계산 함수
  useEffect(() => {
    const total = items.reduce((sum, item) => {
      const variant = product.variants.find(
        (variant) => variant.id === item.variantId
      );

      const price = variant?.discount_price || variant?.price || 0;
      return sum + price * item.quantity;
    }, 0);
    setTotalPrice(total);
  }, [items, product]);

  const handleInputChange = (variantId, value) => {
    setItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex(
        (item) => item.variantId === variantId
      );
      const updatedItems = [...prevItems];

      if (existingItemIndex !== -1) {
        // 기존 아이템 업데이트
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          quantity: value,
        };
      } else {
        // 새로운 아이템 추가
        updatedItems.push({ variantId, quantity: value });
      }
      return updatedItems;
    });
  };
  const handleAddToCart = () => {
    const selectedItems = items.filter((item) => item.quantity > 0);

    if (userName) {
      if (selectedItems.length === 0) {
        toast.error(t("수량을 선택해주세요"), {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return;
      }
      const cartId = getCookie("_medusa_cart_id");
      storeRequester.addItem(
        cartId,
        items.map((item) => ({
          variant_id: item.variantId,
          quantity: item.quantity,
          free: false,
        })),
        () =>
          toast.success(t("장바구니에 추가되었습니다."), {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          })
      );
    } else {
      toast.error(t("로그인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  // 배열을 n개씩 나누는 함수
  const chunkArray = (array, size) => {
    const chunked = [];
    for (let i = 0; i < array.length; i += size) {
      chunked.push(array.slice(i, i + size));
    }
    return chunked;
  };

  const renderPrice = () => {
    

    const customDisplay = getCustomPriceDisplay(product.id);
    if (customDisplay) {
      // 배열인 경우 (여러 줄)와 문자열인 경우 (한 줄) 처리
      if (Array.isArray(customDisplay)) {
        return customDisplay.map((line, index) => (
          <div key={index}>{line}</div>
        ));
      }
      return customDisplay;
    }

    if (product.variants?.length > 0 && product.discount_price) {
      return ` ${addCommas(product.discount_price)}`;
    }

    return ` ${addCommas(product.price)}`;
  };
  return (
    <div className={style.wrap}>
      {product && (
        <Container backgroundColor={"white"} minWidth={1300} maxWidth={1300}>
          <VerticalFlex gap={80}>
            <FlexChild >
              <Container minWidth={1300} maxWidth={1300} borderBottom={'3px solid #ddd'}>
                <HorizontalFlex gap={30}>
                  <FlexChild width={"max-content"} padding={"40px 0 0 0"}>
                    <VerticalFlex gap={30}>
                      <FlexChild>
                        <img
                          src={product.thumbnail}
                          style={{
                            width: "100%",
                            maxWidth: "430px",
                            minWidth: "430px",
                          }}
                        />
                      </FlexChild>
                      <FlexChild>
                        <VerticalFlex>
                          <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                              <P size={20} color={"#222"} weight={700}>
                                {product.title}
                              </P>
                              <P size={16} color={"#222"}>
                                {product.categories &&
                                  product.categories.length > 0 &&
                                  product.categories?.[0].name}
                              </P>
                            </Center>
                          </FlexChild>
                          <FlexChild>
                            <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                              <FlexChild justifyContent={"flex-start"}>
                                <P
                                  width={isMobile ? "150px" : "100%"}
                                  textHover
                                  cursor
                                  textAlign={"left"}
                                  size={isMobile ? 16 : 20}
                                  weight={"bold"}
                                  color={"rgba(89, 87, 87, 1)"}
                                  textDecoration={product.currentPrice && "line-through"}
                                >
                                  {renderPrice()}
                                </P>
                              </FlexChild>
                            </HorizontalFlex>
                            {/* <HorizontalFlex
                              justifyContent={"flex-start"}
                              gap={20}
                            >
                              <FlexChild width={"initial"}>
                                <Center width={"100%"} textAlign={"left"}>
                                  {product &&
                                  product.variants.length > 0 &&
                                  product.discount_price ? (
                                    <FlexChild justifyContent={"flex-start"}>
                                      <P
                                        textHover
                                        cursor
                                        textAlign={"left"}
                                        size={isMobile ? 16 : 20}
                                        weight={"bold"}
                                        color={"rgba(89, 87, 87, 1)"}
                                      >
                                        &#8361;
                                        {userName
                                          ? addCommas(product.discount_price)
                                          : "-"}
                                      </P>
                                    </FlexChild>
                                  ) : (
                                    <FlexChild justifyContent={"flex-start"}>
                                      <P
                                        textHover
                                        cursor
                                        textAlign={"left"}
                                        size={isMobile ? 16 : 20}
                                        weight={"bold"}
                                        color={"rgba(89, 87, 87, 1)"}
                                      >
                                        &#8361;
                                        {userName
                                          ? addCommas(product.price)
                                          : "-"}
                                      </P>
                                    </FlexChild>
                                  )}
                                </Center>
                              </FlexChild>
                            </HorizontalFlex> */}
                          </FlexChild>
                        </VerticalFlex>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild>
                    <VerticalFlex gap={30}>
                      <FlexChild padding={"40px 0px 0px 0px"}>
                        <VerticalFlex gap={20}>
                          <FlexChild>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px",
                              }}
                            >
                              {product.variants &&
                                chunkArray(product.variants, 5).map(
                                  (row, rowIndex) => {
                                    // 부족한 부분을 채울 더미 카드 추가
                                    const filledRow = [
                                      ...row,
                                      ...Array(5 - row.length).fill({
                                        isDummy: true,
                                      }),
                                    ];

                                    return (
                                      <div
                                        key={rowIndex}
                                        style={{ display: "flex", gap: "20px" }}
                                      >
                                        {filledRow.map((variant, index) => (
                                          <div
                                            key={index}
                                            style={{
                                              flex: "1 1 17%",
                                              textAlign: "center",
                                            }}
                                          >
                                            {variant.isDummy ? (
                                              // 더미 카드
                                              <div />
                                            ) : (
                                              // 실제 상품 카드
                                              <VerticalFlex>
                                                <FlexChild>
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <img
                                                      src={variant.thumbnail}
                                                      style={{
                                                        width: "100%",
                                                        borderRadius: "5px",
                                                        opacity:
                                                          (variant.inventory_quantity ===
                                                            0 ||
                                                            variant.sold ===
                                                            true) &&
                                                          0.2,
                                                      }}
                                                    />
                                                    {(variant.inventory_quantity ===
                                                      0 ||
                                                      variant.sold ===
                                                      true) && (
                                                        <div
                                                          style={{
                                                            position: "absolute",
                                                            top: "45%",
                                                            zIndex: 6,
                                                          }}
                                                        >
                                                          <P
                                                            size={20}
                                                            weight={700}
                                                            color={"#ca0000"}
                                                          >
                                                            SOLD OUT
                                                          </P>
                                                        </div>
                                                      )}
                                                  </div>
                                                </FlexChild>
                                                <FlexChild>
                                                  <Inline>
                                                    <P weight={700} size={14}>
                                                      {variant.title}
                                                    </P>
                                                    {/* {(variant.inventory_quantity ===
                                                      0 ||
                                                      variant.sold ===
                                                        true) && (
                                                      <P
                                                        size={10}
                                                        color={"red"}
                                                      >
                                                        {" "}
                                                        품절
                                                      </P>
                                                    )} */}
                                                  </Inline>
                                                </FlexChild>
                                                <FlexChild>
                                                  <InputNumber
                                                    onChange={(value) => {
                                                      handleInputChange(
                                                        variant.id,
                                                        value
                                                      ); // 수정된 핸들러
                                                      setIsIncrease(
                                                        !isIncrease
                                                      );
                                                    }}
                                                    ref={(el) => {
                                                      if (
                                                        el &&
                                                        !variant.isDummy
                                                      ) {
                                                        inputs.current[
                                                          variant.id
                                                        ] = el; // variant.id를 키로 ref 저장
                                                      }
                                                    }}
                                                    required={true}
                                                    height={50}
                                                    max={
                                                      variant.inventory_quantity ===
                                                        0 ||
                                                        variant.sold === true
                                                        ? 0
                                                        : variant.inventory_quantity
                                                    }
                                                    isAllowed={true}
                                                  />
                                                </FlexChild>
                                              </VerticalFlex>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </FlexChild>
                        </VerticalFlex>
                      </FlexChild>
                      <FlexChild>
                        <HorizontalFlex gap={50}>
                          <FlexChild justifyContent={"flex-start"}>
                            <VerticalFlex flexStart>
                              <FlexChild>
                                <P size={24} weight={700} color={"#222"}>
                                  총 금액: &#8361;{" "}
                                  {userName ? addCommas(totalPrice) : "-"}
                                </P>
                              </FlexChild>
                            </VerticalFlex>
                          </FlexChild>
                          <FlexChild justifyContent={"flex-end"}>
                            {/* 일괄 담기 버튼 */}
                            <button
                              onClick={() => handleAddToCart()}
                              style={{
                                backgroundColor: "var(--main-color)",
                                color: "#fff",
                                padding: "10px 20px",
                                border: "none",
                                borderRadius: "5px",
                                fontSize: "16px",
                                cursor: "pointer",
                                fontWeight: 700,
                                width: "83.5%",
                              }}
                            >
                              <img
                                src={cartIcon}
                                style={{ color: "white", width: "35px" }}
                              />{" "}
                              장바구니에 일괄 담기
                            </button>
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                </HorizontalFlex>
                <Dummy height={50} />
              </Container>
            </FlexChild>
            <FlexChild>
              <PaddingWrapper padding={"0px 10px"}>
                <Container maxWidth={900}>
                  {// to-do remove
                    product?.content ? (
                      <QuillViewer
                        value={
                          product.content?.startsWith("PHA")
                            ? decode(product.content)
                            : product.content
                        }
                      />
                    ) : (
                      <img
                        src={product.images?.[0]?.url}
                        style={{ width: "100%" }}
                        alt="empty"
                      />
                    )}
                </Container>
              </PaddingWrapper>
            </FlexChild>
          </VerticalFlex>
        </Container>
      )}
    </div>
  );
}

export default DeskTopProductDetail;
